// flow
import { CycleType } from '../types';

export const toCurrency = (num: number) => num.toLocaleString('US', { maximumFractionDigits: 0 });

export const centsToCurrency = (num: number) => toCurrency(num / 100);

export const cardTitle = (name: string, selectedCycleType: CycleType) =>
  name.replace(`${selectedCycleType} - `, '');
